import { render, staticRenderFns } from "./SelectorTags.vue?vue&type=template&id=079c2464&"
import script from "./SelectorTags.vue?vue&type=script&lang=js&"
export * from "./SelectorTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports